
import { computed, defineComponent } from "vue";
import KTUserMenu from "@/layouts/main-layout/menus/UserAccountMenu.vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "header-topbar",
  components: {
    KTUserMenu,
  },
  setup() {
    const store = useStore();

    const UserNameInitial = computed(() => {
      const { firstName, lastName } = store.getters["user/currentUser"];
      let result = "";
      if (firstName && lastName && lastName[0] !== "<") {
        result = firstName[0] + lastName[0];
      } else {
        result = "U"; // First letter of User;
      }
      return result;
    });

    const currentUser = computed(() => {
      return store.getters["user/currentUser"];
    });

    return { currentUser, UserNameInitial };
  },
});
